module.exports = __webpack_public_path__ + "static/media/animated-ca.bbf1c8bc.gif";